export default __webpack_public_path__ + "static/media/RamachandraGuha.5f23729b.png";